import React, { Component,Fragment } from 'react';
import ReactTable from 'react-table';
import NotificationSystem from 'react-notification-system';
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import { get } from '../../../server/actions'
import CalenderCarousel from './CalenderCarousel/CalenderCarousel';
import {getLoginCatererInfo} from "../../../server/utilCaterer";
import PrintLabels from '../../SchoolAdmin/Reports/printLabels';
import TmExportExcel from '../../../components/Misc/tmExportExcel/tmExportExcel';
import moment from 'moment'
import MenuCalender from '../../SchoolAdmin/Reports/AdminReports/menuCalender/menuCalender';
import { groupBy,numberParce,showFile, _addNotification, _addNotificationError } from '../../../server/util';
const userInfo=getLoginCatererInfo();
const defaultOrdersTableObj={
    day:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('d'),
            endDate: moment().endOf('d'),
            cDate:moment()
        }
    },
    week:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('w'),
            endDate: moment().endOf('w'),
            cDate:moment()
        }
    },
    month:{
        orders:[],
        summary:{},
        selectedDates:{
            startDate:moment().startOf('M'),
            endDate: moment().endOf('M'),
            cDate:moment()
        }
    }
}
class OrderDetails extends Component {
    constructor(props){
        super(props)
        this.state={
            loading:false,
            mealType:'',
            tableView:'',
            viewBy:'Day',            
            sid:0,
            schoolYear:'',
            ordersTable: {
                data: JSON.parse(JSON.stringify(defaultOrdersTableObj))
            },
            dataExport:[],
            sessions:[],
            grades:[],
            gradesBySession:[],
            selectedSession:'All',
            selectedGrade:'All'
        }
    }
    componentWillMount=()=>{
       const data=this.context.router.history.location.state;
       this.setState({
           tableView:data.data.tableView, 
           schoolList:data.props.schoolList,
           mealType:data.props.mealType,
           data:data.data.data,
           sid:data.data.sid,
           schoolYear:data.data.schoolYear
         })
         this.props.showHideSchoolsDropdown(false);
    }
    componentWillReceiveProps = (nextProps) => {
        this.setState({ mealType: nextProps.mealType }, () => {
            this.getOrders(this.state.tableView);
        })
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getSessionGradeList();
    }
    buildDataFormatForExport=()=>{
        const {ordersTable, tableView}=this.state;
        const data=(ordersTable.data[this.tableViewKey(tableView)]||{}).orders||[];
        let itemNameCol=['itemName'];
        let dateCol=[];
        let summaryCol=['total'];
            data.map(row=>{
                Object.keys(row).map(key=>{
                    if(key!=='itemName' && key!=='total'){
                        dateCol.push(key);
                    }
                })                               
            });
            const sortedDates= [...new Set(dateCol)].sort((a,b)=>{
                let dateA = moment(a,'YYYY-MM-DD');
                let dateB = moment(b,'YYYY-MM-DD');
                return dateA > dateB ? 1 : -1;
            });
        const cols=[...itemNameCol, ...sortedDates,...summaryCol]
             

        return (
            [{
              columns: cols.map(col=>{
                    if(col=='itemName'){
                        return {title: 'Item Name'}
                    }
                    else if(col=='total'){
                        return {title: 'Total'}
                    }else{
                        return {title: col}
                    }
              }),
              data: data.map(item => {
                return cols.map(col=>{
                    return {value: item[col] || ''}
                })
              })
            }]
          )
    }
    
    getCatererReportPdf = () => {
	    this.setState({loading: true});
        const {selectedSession, sid, selectedGrade, gradesBySession, mealType, viewBy, tableView}=this.state;
        const periodKey=(tableView==='MONTH'?'month':(tableView==='WEEK'?'week':'day'));
        const dateStart = moment(this.state.ordersTable.data[periodKey].selectedDates.startDate).format('YYYY-MM-DD');
        const dateEnd = moment(this.state.ordersTable.data[periodKey].selectedDates.endDate).format('YYYY-MM-DD');
        let _selectedGradesString=this.getSelectedGrades();
        
        let url= (selectedSession == 'All' && selectedGrade == 'All') ?`/reports/catererExportReport?isVersion2=true&mealSchoolId=${sid}&startDate=${dateStart}&endDate=${dateEnd}&menuType=${mealType}&fileType=Pdf&byItem=${viewBy==='Day'?false:true}&access_token=`
            :
            `/reports/catererExportReport?isVersion2=true&mealSchoolId=${sid}&grades=${_selectedGradesString}&startDate=${dateStart}&endDate=${dateEnd}&menuType=${mealType}&fileType=Pdf&byItem=${viewBy==='Day'?false:true}&access_token=`;
            
            get(url).then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }else{
                    throw Error(response.statusText);
                    }
                }		        
                return response;                
            }).then(resp=>{
                this.setState({loading: false});
                if (resp.statusCode === 417) {
                     _addNotificationError(resp.statusMessage,this);
                     throw Error(resp.statusMessage);
                }else{
                    return resp.blob();
                }
            }).then(blob => {
                
                    let filename = "Caterer Reports for " /* + (grade === 0 ? 'all grades' : 'grade-' + grade) */;
        
                    //if (fileType === "Pdf") {
                    // download(blob,filename + '.pdf', "pdf");
                    showFile(blob,filename);
                    //}
                /*  else {
                        download(blob,
                            filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    } */
                
            }).catch(error => {
		        this.setState({loading: false});
                console.log("Download Failed", error)
            });
    };
    getSessionGradeList=()=>{
        const {sid}=this.state;
        this.setState({loading:true})
        get(`/schoolSessionsGrades/${sid}?access_token=`).then((response) => {
            if (!response.statusCode===200) {
                throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response.json();
        }).then(res => {
            const {resp,grades}=res
            let _sessions=[];
            let _grades=[];
            if((resp||[]).length>0){
                const gradesObj=groupBy(grades,'value');
            (resp||[]).map((rec)=>{
                _sessions.push({id:rec.id,name:rec.session, grades:(rec.grades||[]).map(g=>{
                    return gradesObj[g][0]
                })});               
            });
            _grades=grades;
        }else{
            _grades=grades;
        }
            this.setState({sessions:_sessions, grades:_grades, gradesBySession:_grades, loading:false},()=>{
                this.getOrders(this.state.tableView);
            });            
        }).catch(
            (error) => {
                _addNotificationError(error, this)
                this.setState({loading:false})
                console.log('Get Order History response', error)
            }
        )
    }
    getColumns=(arrayData)=>{
        let res = arrayData.reduce((arr, o) => {
            return Object.keys(o).reduce((a, k) => {
               if (a.indexOf(k) == -1) a.push(k);
                  return a;
               }, arr)
            }, []);
            let itemNameCol=[];
            let dateCol=[];
            let summaryCol=[];
            res.map(col=>{
                if(col==='itemName'){
                    itemNameCol.push({
                        Header:'Item Name',
                        width:300,
                        accessor:col
                    })
                }else if(col==='total'){
                    summaryCol.push({Header:'Total', accessor:'total', style: {textAlign: 'center'}});
                }else{
                    dateCol.push({
                        date:moment(col,'YYYY-MM-DD').format('YYYY-MM-DD'),
                        Header:moment(col,'YYYY-MM-DD').format('MM/DD'),
                        style: {textAlign: 'center'},
                        accessor:col
                    });
                }                
            });            
            const sortedDates=dateCol.sort((a,b)=>{
                let dateA = moment(a.date,'YYYY-MM-DD');
                let dateB = moment(b.date,'YYYY-MM-DD');
                return dateA > dateB ? 1 : -1;
            })
            return [...itemNameCol, ...sortedDates,...summaryCol]
    }
    bindMonthDataTable=()=>{
        const {ordersTable,sid, tableView}=this.state;
        const _orders= ordersTable.data[this.tableViewKey(tableView)].orders;
        const mDate=ordersTable.data[this.tableViewKey(tableView)].selectedDates.startDate;
        const _ordersList=[]
        _orders.map(itm=>{
            const keys=Object.keys(itm);
            keys.splice(keys.indexOf('itemName'),1);
            keys.map(dt=>{
                _ordersList.push({
                    itemName:itm.itemName,
                    date:dt,
                    count:itm[dt]
                })
            })
        });

        const orderDateGroup=groupBy(_ordersList,'date')
        const items=[];
        Object.keys(orderDateGroup).map((key,i)=>{
            (Object.keys(orderDateGroup[key])||[]).forEach(itm=>{
                const m=moment(key,'YYYY-MM-DD').month();
                const y=moment(key,'YYYY-MM-DD').year();
                const d=moment(key,'YYYY-MM-DD').date();
                items.push({
                    "id" : 2300,
                    "type" : "MEAL",
                    "title" : (orderDateGroup[key][itm]||{}).itemName||'',
                    "start" : new Date(y, m, d),
                    "end" : new Date(y, m, d),
                    "desc" : null,
                    "price" : 0,
                    "reducedPrice" : 0,
                    "count":(orderDateGroup[key][itm]||{}).count||0
                  })
            });
        })
        const _date=new Date(moment(mDate).year(),moment(mDate).month(),moment(mDate).date());
        return <MenuCalender date={_date} orderedMenu={items}
         />
    }

    bindMonthDataTableByItem=()=>{
        const {ordersTable,sid, tableView}=this.state;
        const _orders= ordersTable.data[this.tableViewKey(tableView)].orders;
        const mDate=ordersTable.data[this.tableViewKey(tableView)].selectedDates.startDate;
        const _ordersList=[];
        if(_orders.length===0){
            return(<div className='row'>
                <div className='col-md-12 text-center'>
                    <span style={{
                        isplay: 'block',
                        padding: '20px',
                        color: 'rgba(0,0,0,0.5)',
                    }}>No data found</span>
                </div>
            </div>)
        }
        _orders.map(itm=>{
            const keys=Object.keys(itm);
            keys.splice(keys.indexOf('itemName'),1);
            keys.map(dt=>{
                _ordersList.push({
                    itemName:itm.itemName,
                    date:dt,
                    count:itm[dt]
                })
            })
        });
        const _date=new Date(moment(mDate).year(),moment(mDate).month(),moment(mDate).date());
        const ordersItemsByItem=groupBy(_ordersList,'itemName');
        const itemsObj={};
        if(tableView==='MONTH'){
            Object.keys(ordersItemsByItem).map((key,i)=>{
                itemsObj[key]={items:[]};
                (ordersItemsByItem[key]||[]).forEach((item,j)=>{
                    const m=moment(item.date,'YYYY-MM-DD').month();
                    const y=moment(item.date,'YYYY-MM-DD').year();
                    const d=moment(item.date,'YYYY-MM-DD').date();
                    itemsObj[key].items.push({
                        "id" : `${i}-${j}`,
                        "type" : "MEAL",
                        "title" : key||'',
                        "start" : new Date(y, m, d),
                        "end" : new Date(y, m, d),
                        "desc" : null,
                        "price" : 0,
                        "reducedPrice" : 0,
                        "count":item.count||0
                      })
                });
            })
            return <Accordion accordion={false}>
                {Object.keys(itemsObj).map(e => (<AccordionItem expanded={true}>
                    <AccordionItemTitle style={{ textAlign: 'center' }}>
                        <h3>{e}</h3>
                    </AccordionItemTitle>
                    <AccordionItemBody>                      
                        <MenuCalender date={_date} orderedMenu={itemsObj[e].items||[]}
                        //hiddenDays={getNotWorkingDays()} 
                        />
                    </AccordionItemBody>
                </AccordionItem>))}
            </Accordion>
        }else{

            return <Accordion accordion={false}>
                {_orders.map(e => (<AccordionItem expanded={true}>
                    <AccordionItemTitle style={{ textAlign: 'center' }}>
                        <h3>{e.itemName}</h3>
                    </AccordionItemTitle>
                    <AccordionItemBody>
                         <ReactTable
                            data={[e]}
                            columns={this.getColumns([e])}
                            defaultPageSize={10}
                            minRows = {2}
                            className="-striped -highlight rtTable-Order"
                            noDataText='No data found'
                            showPagination={true}
                        />
                    </AccordionItemBody>
                </AccordionItem>))}
            </Accordion>

        }
    }
    tableViewKey=(tableView)=>(tableView==='WEEK'?'week':(tableView==='MONTH'?'month':'day'));
    getSelectedGrades=()=>{
        const {selectedGrade, selectedSession, gradesBySession}=this.state
        let _selectedGradesString='';
        if(selectedSession!=='All'){
            if(selectedGrade=='All'){
                _selectedGradesString=(gradesBySession||[]).map(g=>g.value).join(',');
            }else{
                _selectedGradesString=selectedGrade;
            }
        }else{
            _selectedGradesString=selectedGrade;
        }
        return _selectedGradesString;
    }
    getOrders = (tableView) => {
        const {selectedSession, sid, selectedGrade, gradesBySession, mealType}=this.state;
        const periodKey=(tableView==='MONTH'?'month':(tableView==='WEEK'?'week':'day'));
        const dateStart = moment(this.state.ordersTable.data[periodKey].selectedDates.startDate).format('YYYY-MM-DD');
        const dateEnd = moment(this.state.ordersTable.data[periodKey].selectedDates.endDate).format('YYYY-MM-DD');
        let _selectedGradesString=this.getSelectedGrades();
        const _url = (selectedSession == 'All' && selectedGrade == 'All') ? `/reports/catererReport?isVersion2=true&menuType=${mealType}&mealSchoolId=${sid}&startDate=${dateStart}&endDate=${dateEnd}&access_token=` :
            `/reports/catererReport?isVersion2=true&menuType=${mealType}&mealSchoolId=${sid}&grades=${_selectedGradesString}&startDate=${dateStart}&endDate=${dateEnd}&access_token=`;
        get(_url)
            .then((response) => {
                this.setState({ loading: true })
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(respData => {
                console.log('data', respData);
                let orders = [];
                let orderArray = [];
                    Object.keys(respData.dateMealItemCountMap||{}).map(date => {  
                        const recObj=(respData.dateMealItemCountMap||{})[date] || {};                      
                        Object.keys(recObj).map(key => {
                            orderArray.push({ date: date, itemName:key, count:recObj[key] })
                        })
                    })
                    const itemNameGroup = groupBy(orderArray, 'itemName');
                Object.keys(itemNameGroup).map(itemName => {
                    const dateGroup = groupBy(itemNameGroup[itemName] || [], 'date')
                    const res = {};
                    res.itemName = itemName;
                    let total=0;
                    Object.keys(dateGroup).map(date => {
                        res[date] =  numberParce(((dateGroup[date]||[])[0]||{}).count);
                        total=total+numberParce(((dateGroup[date]||[])[0]||{}).count)
                    });
                    res.total=total;
                    orders.push(res);
                })
                
                let _ordersTable = this.state.ordersTable;
                _ordersTable.data[periodKey].orders= orders;
                //_ordersTable.data[periodKey].summary= summary;
                this.setState({ ordersTable: _ordersTable, loading: false })
            }).catch(
                (error) => {
                    this.setState({ loading: false })
                    console.log('Get School data response', error)
                }
            );
    }
    onChangeDateRange=(start, end) => {
        const _orderTable = this.state.ordersTable;
        _orderTable.selectedDates.startDate = start;
        _orderTable.selectedDates.endDate = end;
        this.setState({ ordersTable: _orderTable }, () => {
            this.getOrders(this.state.tableView);
        })
    }
    onTableViewChange=(view)=>{
        this.setState({tableView:view});
        this.getOrders(view);
    }
    render() {
        const {schoolList,tableView, viewBy, sessions, grades,  schoolYear,
            gradesBySession, sid, selectedSession,selectedGrade, ordersTable, mealType}=this.state;
        const schoolListObj=groupBy(schoolList,'schoolId');
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container">
                    <div className='row'>
            <div className="col-md-12">
        <div className="panel chart-panel" style={{height:'auto'}}>
        <div style={{ 
            display: 'inline-block', 
            backgroundColor: 'transparent',             
            margin: '0px', 
            float: 'right', 
            borderRadius: '3px' }}>              
              <div className="btn-group">
                <button className="btn-link btn-sm dropdown-toggle" type="button" 
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{color:'rgb(234 112 102)', fontSize:'13px'}}>
                  <i className="fa fa-file" aria-hidden="true"></i> Export <span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                  <li>
                    <a title="Click to Download PDF" style={{cursor:'pointer'}}
                    onClick={() => this.getCatererReportPdf()}
                    target='_blank'
                    ><i className="fa fa-file-pdf-o" /> Pdf</a>
                  </li>
                  <li>
                    <TmExportExcel id="catererReport" 
                        name={"Caterer Report"}
                        filename={"Caterer Report"}
                        element={<a title="Click to Download Excel" 
                        style={{ 
                          display: 'block',  
                          padding: '3px 20px',
                          clear: 'both',
                          fontWeight: '400',
                          lineHeight: 1.42857143,
                          color: '#333',
                          whiteSpace: 'nowrap',
                          cursor:'pointer'
                        }}
                        ><i className="fa fa-file-excel-o" /> Excel</a>}
                        dataSet={this.buildDataFormatForExport()}
                    />
                    
                  </li>             
                </ul>
              </div>
              {tableView == 'DAY' ?<div className="btn-group">
                <button className="btn-link btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                style={{color:'rgb(234, 112, 102)', fontSize:'13px'}}>
                  <i className="fa fa-print" aria-hidden="true"></i> Print Labels <span className="caret"></span>
                </button>
                <ul className="dropdown-menu">
                  <li style={{cursor:'pointer'}}>                  
                    <PrintLabels 
                        {...this.props} 
                        mealType={mealType} 
                        showButtonAs={'label'} buttonLabel={'Print'}
                            grade={this.getSelectedGrades()=='All' ?[]:this.getSelectedGrades()} 
                            isCaterer={sessionStorage.getItem('ROLE')=='ROLE_CATERER'?true:false}
                            schoolYear={schoolYear}
                            selectedDate={moment(ordersTable.data.day.selectedDates.startDate).format('YYYY-MM-DD')} 
                            showErrorMessage={(message) => {
                                _addNotificationError(message, this);
                            }}
                        schoolId={sid} />
                                              
                  </li> 
                                  
                </ul>
              </div>: null
                    }
              </div>          
            <div className="panel-heading text-center" style={{padding:'0px'}}>
                <span className="panel-title" style={{fontSize: '14px', fontWeight:'600'}}>{`${((schoolListObj[sid]||[])[0]||{}).schoolName} Order details`}</span>
                <p style={{fontSize: '12px', fontWeight:'600'}}></p>
            </div>
            <div className="panel-body" style={{padding:'0px'}}>
                <div className='row' style={{paddingBottom:'7px'}}>
                    <div className='col-md-12 text-center'>
                        {tableView == 'WEEK' ? 
                                    <CalenderCarousel type={"Week"} date={moment(ordersTable.data.week.selectedDates.cDate)} 
                                    startDate={moment(ordersTable.data.week.selectedDates.startDate)} 
                                    endDate={moment(ordersTable.data.week.selectedDates.endDate)} 
                                    dateChange={({start,end, cDate})=>{
                                        let _start=moment(start);
                                        let _end=moment(end);
                                        const _ordersTable={...this.state.ordersTable};
                                        _ordersTable.data.week.selectedDates={startDate:_start,endDate:_end,cDate:moment(cDate)}
                                        this.setState({ordersTable:_ordersTable},()=>{
                                            this.getOrders('WEEK');
                                        })
                                    }} />
                                    : tableView == 'MONTH' ?
                                    <CalenderCarousel type={"Month"} 
                                    date={moment(ordersTable.data.month.selectedDates.cDate)} 
                                    startDate={moment(ordersTable.data.month.selectedDates.startDate)} 
                                    endDate={moment(ordersTable.data.week.selectedDates.endDate)} 
                                    dateChange={({start,end, cDate})=>{
                                        let _start=moment(start);
                                        let _end=moment(end);
                                        const _ordersTable={...this.state.ordersTable};
                                        _ordersTable.data.month.selectedDates={startDate:_start,endDate:_end,cDate:moment(cDate)}
                                        this.setState({ordersTable:_ordersTable},()=>{
                                            this.getOrders('MONTH');
                                        })
                                    }} />
                                    :
                                    <CalenderCarousel type={"Day"} 
                                    date={moment(ordersTable.data.day.selectedDates.cDate)} 
                                    startDate={moment(ordersTable.data.day.selectedDates.startDate)} 
                                    endDate={moment(ordersTable.data.day.selectedDates.endDate)} 
                                    dateChange={({start,end, cDate})=>{
                                        let _start=moment(start);
                                        let _end=moment(end);
                                        const _ordersTable={...this.state.ordersTable};
                                        _ordersTable.data.day.selectedDates={startDate:_start,endDate:_end,cDate:moment(cDate)}
                                        this.setState({ordersTable:_ordersTable},()=>{
                                            this.getOrders('DAY');
                                        })
                                    }} />}
                    </div>                   
                </div>
                <div className='row'>
                    <div className="col-xs-3 text-right">
                        <div id="filteredBy" className="btn-group">
                        <button id="Day" type="button" className={tableView=== "DAY"? "btn btn-xs btn-inactive-color active":"btn btn-xs btn-inactive-color"}
                                     onClick={() => { 
                                         this.onTableViewChange("DAY");                                
                                       }} 
                                    style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                >Day </button>
                            <button id="Week" type="button" className={tableView=== "WEEK"? "btn btn-xs btn-inactive-color active":"btn btn-xs btn-inactive-color"}
                                     onClick={() => { 
                                         this.onTableViewChange("WEEK");                                
                                       }} 
                                    style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                >Week </button>
                            <button id="Month" type="button" className={tableView=== "MONTH"?"btn btn-xs btn-inactive-color active":"btn btn-xs btn-inactive-color"}
                                   onClick={() => { 
                                    this.onTableViewChange("MONTH");
                                  }}
                                    style={{ margin: 0, marginLeft: 5, fontSize: 14 }}
                                >Month </button>
                        </div>
                    </div>
                    <div className="col-xs-2">
                        <select className="form-control" id={"selectBy"} value={viewBy}
                            onChange={(e) => this.setState({ viewBy: e.target.value },()=>{                               
                                })}>
                            <option value={"Day"}>By Day</option>
                            <option value={"Items"}>By Items</option>
                        </select>
                    </div>
                    <div className="col-md-4 text-left">
                        <form className="form-inline">
                            <div className="form-group" style={{paddingRight:'5px'}}>
                                <label htmlFor="selectedSession" style={{paddingRight:'5px'}}>Sessions: </label>
                                <select className="form-control" 
                                    id={"selectedSession"} value={selectedSession}
                                         onChange={(e) => {
                                             let _gradesBySession=[];
                                             if(e.target.value==='All'){
                                                _gradesBySession=grades;
                                             }else{
                                                 const sessionObj=groupBy(sessions,'id');
                                                 _gradesBySession=((sessionObj[e.target.value]||[])[0]||{}).grades||[];
                                             }
                                        this.setState({ selectedSession: e.target.value, 
                                            selectedGrade:'All', 
                                            gradesBySession:_gradesBySession },()=>{
                                                this.getOrders(tableView);                                           
                                        })}}
                                        >
                                    <option value={"All"}>All</option>
                                        {
                                        sessions.map((session,i)=>{
                                            return <option value={session.id} key={i}>{session.name}</option>
                                        })                          
                                        }
                                </select>
                            </div>
                            <div className="form-group">
                                <label htmlFor="selectBy" style={{paddingRight:'5px'}}>Grades: </label>
                                <select className="form-control" id={"selectBy"} value={selectedGrade}
                                        onChange={(e) => {
                                            this.setState({ selectedGrade: e.target.value },()=>{
                                                this.getOrders(tableView);                                                
                                            });
                                        }}>
                                        <option value={"All"}>All</option>
                                         {(gradesBySession||[]).map((item,i)=> {
                                        return <option
                                            value={item.value} key={i}>{item.label}</option>
                                        }, this)} 
                                </select>
                            </div>
                        </form>
                    </div>
                    <div className='col-md-3 text-right'>
                        <button className="btn btn-xs btn-warning" style={{margin:'0px'}} onClick={() => {
                            const _orderTable = this.state.ordersTable;
                            _orderTable.sid = 0,
                            _orderTable.showOrderDetails = false;
                            _orderTable.data=JSON.parse(JSON.stringify(defaultOrdersTableObj)),
                            this.setState({ ordersTable: _orderTable },()=>{
                                this.context.router.history.push({ 
                                    pathname: '/caterer/orders'
                                } );
                            });
                        }}>Back</button>
                    </div>
                </div>
                 <div className='row' style={{paddingTop:'5px'}}>
                    <div className='col-md-12'>
                        {
                            viewBy=='Day'?
                                (tableView==='MONTH'?
                                    this.bindMonthDataTable()                            
                                :
                                    <ReactTable
                                        data={ordersTable.data[this.tableViewKey(tableView)].orders}
                                        columns={this.getColumns(ordersTable.data[this.tableViewKey(tableView)].orders)}
                                        defaultPageSize={10}
                                        minRows = {2}
                                        className="-striped -highlight rtTable-Order"
                                        noDataText='No data found'
                                        showPagination={true}
                                    />)
                                :
                                this.bindMonthDataTableByItem()
                        }                  
                    </div>
                </div>
            
            </div>                
        </div>
        </div>
    </div>
    </div>
    </section>
        );
    }
}
OrderDetails.contextTypes = {
    router: PropTypes.object.isRequired
}
export default OrderDetails;


// WEBPACK FOOTER //
// ./src/components/Caterer/Orders/orderDetails.jsx